const permissions = (permission, result = new Set()) => {
  return {
    systemAdmin: () => permissions("SYSTEM_ADMIN", result),
    account: () => permissions("ACCOUNT", result),
    consumption: () => permissions("CONSUMPTION", result),
    payment: () => permissions("PAYMENT", result),
    paymentHistory: () => permissions("PAYMENT_HISTORY", result),
    paymentSettlement: () => permissions("PAYMENT_SETTLEMENT", result),
    systemConfig: () => permissions("SYSTEM_CONFIG", result),
    rolePermission: () => permissions("ROLE_PERMISSION", result),
    profile: () => permissions("PROFILE", result),
    organization: () => permissions("ORGANIZATION", result),
    orgConfig: () => permissions("ORG_CONFIG", result),
    consumptionSummary: () => permissions("CONSUMPTION_SUMMARY", result),
    read: () => {
      result.add(`${permission}_READ`);
      return permissions(permission, result);
    },
    create: () => {
      result.add(`${permission}_CREATE`);
      return permissions(permission, result);
    },
    update: () => {
      result.add(`${permission}_UPDATE`);
      return permissions(permission, result);
    },
    delete: () => {
      result.add(`${permission}_DELETE`);
      return permissions(permission, result);
    },
    all: () => {
      return permissions(permission, result).read().create().update().delete();
    },
    list: () => [...result],
  };
};

export default permissions;
